import { FilterType } from "./FilterType";

/** Filter types that don't require a value (IsEmpty, IsNotEmpty) */
export const isReadOnlyFilterType = (filterType?: FilterType): boolean =>
  filterType === FilterType.IsEmpty || filterType === FilterType.IsNotEmpty;

/** Filter value is valid: has value OR is value-less type */
export const isValidFilterTypeAndValue = (
  filterType: FilterType,
  value?: string,
): boolean =>
  (value !== undefined && value !== "") || isReadOnlyFilterType(filterType);

/** True when filter should be removed: value-less type stays, empty value on value-required type removes */
export const shouldRemoveFilterWhenEmpty = (filterValue: {
  filter?: FilterType;
  value?: string;
}): boolean =>
  !isReadOnlyFilterType(filterValue.filter) && filterValue.value === "";
